import axios from 'axios';
import { variables } from "../Variables";

export const titleSafeParse = (value) => {
    if (typeof value === "object" && value !== null) return value; // already object
    try { return JSON.parse(value); } catch { return null; }
};

export const getWhiseTokenBaseOnUserAccountType = async () => {
    try {
        let url = "https://mink-mtsi-api.net7.be/api/User/GetWhiseTokenPerApp?appName=mtsi";

        let headers = {
            'Content-Type': 'application/json'
        };

        let resp = await axios.post(url, {},
            {
                headers: headers
            });
        if (resp && resp.data && resp.data.token) {
            return resp.data.token;
        }
    }
    catch (e) {
        console.log(e);
    }
}

export const getClientWhiseTokenByAccountType = async (clientWhisetoken, clientId, accountType, officeId) => {
    try {
        let url = `https://mink-mtsi-api.net7.be/api/User/GetWhiseClientTokenByAccountTypeForOtherSites?whiseToken=${clientWhisetoken}&clientId=${clientId}&accountType=${accountType}&officeId=${officeId}`;

        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, {}, config);

        if (response.data.token) {
            return response.data.token;
        }
    }
    catch (e) {
        console.log(e);
    }
}

export const arrayNoMatchingValues = (arr1, arr2) => {
    const set = new Set(arr2.map(item => item.value));
    return arr1.some(item => set.has(item.value));
}

// add action logs
export const addNewActionsLog = async (body) => {
    try {
        let url = `${variables.API_URL}LocalEvents/LogAction`;

        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, body, config);

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}

// get property status from estate table in local db
export const getEstateStatusFromInDB = async (estateId, clientId) => {
    try {       // replace propertyId => getActiveLatestEstateIdInDB
        let url = `${variables.API_URL}LocalEvents/GetEstateStatus?estateId=${estateId}&clientId=${clientId}`;
        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.get(url, config);
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}

